<template>
<div class="selectTable">
	<div class="brand border">
		<a :href="`//price.pcauto.com.cn/price/nb${bid}/`" @click="countAd(4221)" target="_blank"><img :src="brandData.logo || $brandLogoDefaultImgUrl"></a>
		<div class="info">
			<strong>
				<a :href="brandData.all_sg_link" target="_blank" @click="countAd(4222)">{{brandData.name}}</a>
			</strong>
			<div class="doc">{{brandData.desc}}<a :href="brandData.desc_link" target="_blank" @click="countAd(4223)">详细 &gt;&gt;</a>
			</div>
		</div>
	</div>
	<div class="price border ks_price">
		<span class="w70">价&nbsp;&nbsp;格：</span>
			<span><a href="javascript:;" class="lab-color" @click="priceActive(priceLabels1)" :class="[priceLabels1.disabled ? 'null' : 'normal' , priceLabels1.selected ? 'select' : '']">{{priceLabels1.label}}</a></span>
		<span class="w500">
			<a href="javascript:;" @click="priceActive(price)" class="lab-color" :class="[price.disabled ? 'null' : 'normal' , price.selected ? 'select' : '']" v-for="(price,pindex) in priceLabels" :key="pindex">{{price.label}}</a>
		</span>
	</div>
	<div class="price border clearfix ks_level">
		<span class="w70">级&nbsp;&nbsp;别：</span>
			<span><a href="javascript:;" class="lab-color" @click="kindActive(kindLabels1)" :class="[kindLabels1.disabled ? 'null' : 'normal' , kindLabels1.selected ? 'select' : '']">{{kindLabels1.label}}</a></span>
		<span class="w500 h45">
    		<a href="javascript:;" class="lab-color" @click="kindActive(kind)" :class="[kind.disabled ? 'null' : 'normal' , kind.selected ? 'select' : '']" v-for="(kind,kindex) in kindLabels2" :key="kindex">{{kind.label}}</a>
            <div class="ul-wrap">
                <!-- 下拉选项S -->
                <ul class="selectUl" v-for="(downPull,downIndex) in kindLabels3" :key="downIndex">
                    <li>
                        <a href="javascript:;" class="on" :class="{'active' : kindActiveLists[downIndex].selected}">{{kindActiveLists[downIndex].label}}</a>
                        <a href="javascript:;" @click="kindActive(downPull)">{{downPull.label}}</a>
                    </li>
                    <li v-for="(downItem,pullInex) in downPull.sub_kind_labels" :key="pullInex"><a @click="kindActive(downItem)" :class="{'noAc':downItem.disabled}" href="javascript:;" >{{downItem.label}}</a></li>
                    <i class="iDown"></i>
                </ul>
                <!-- 下拉选项E -->
            </div>
		</span>
	</div>
	<div class="price">
		<span class="w70">筛选车系：</span>
		<div class="w540 ks_car">
            <div v-if="serialGroups.length">
                <ul class="rmcx border3" v-for="(serial,index) in serialGroups" :key="index">
                    <li class="ml20" v-for="(item,i) in serial" :key="i">
                        <a class="car-img-link" :href="item.link" target="_blank" :title="item.name"><img class="car-img" alt="" :src="getImgUrl(item)"></a>
                        <p class="p1"><a :href="item.link" target="_blank" @click="countAd(4226)">{{item.name}}</a></p>
                        <p class="p2"><a :href="item.price_link" target="_blank" @click="countAd(4227)">{{item.price}}</a></p>
                    </li>
                </ul>
            </div>
            <div v-else>无车系信息</div>
        </div>
	</div>
	<a :href="brandData.all_sg_link" target="_blank" class="more" @click="countAd(4228)">查看全部车系</a>
</div>
</template>

<script>
export default {
  name: "BrandHead",
  props: {
      bid: {
          type: Number,
          default: 0
      }
  },
  data() {
    return {
        priceLabels1: {}, //价格选项的第一个值
        priceLabels: [], //价格选项
        kindLabels1: {}, //类型选项的第一个值
        kindLabels2: [], //类型选项的没有子值的类型
        kindLabels3: [], //类型里面带子值的类型
        kindActiveLists: [], //类型下拉激活的选项列表
        serialGroups: [], //车系列表
        price: 0, //价格参数
        kid: 0, //类型参数
        brandData: {}, //结果数据
    };
  },
  methods: {
    // 类别点击
    kindActive(item) {
        this.countAd(4225)
        this.kid = item.id
    },
      // 类别点击
    priceActive(item) {
        this.countAd(4224)
        this.price = item.id
    },
    async reqBrand () {
        try {
            const res = await this.fetIndexBrandDataChange({
                bid:this.bid,
                price: this.price,
                kid: this.kid
            })
            /* 数组二维化,控制样式S */
            let list = []
            if(res.serial_groups) {
                for(let i=0; i<Math.ceil(res.serial_groups.length/4); i++){
                    let start = i*4;
                    let end = start+4;
                    list.push(res.serial_groups.slice(start,end));
                }
                this.serialGroups = list
            }else {
                this.serialGroups = []
            }
            let priceLabels = res.price_labels
            let kindLabels = res.kind_labels
            this.priceLabels1 = priceLabels[0]
            this.priceLabels = priceLabels.filter((v,i) => {return i >0})

            this.kindLabels1 = kindLabels[0]
            this.kindLabels2 = kindLabels.filter((v,i) => {return i >0 && !v.sub_kind_labels})

            let tempKindLabels3 = kindLabels.filter((v) => {return v.sub_kind_labels})
            this.kindLabels3 = tempKindLabels3
            let tempKindActiveLists =[]
            tempKindLabels3.map((value,index) => {
               let tempqq = value.sub_kind_labels.find((k,i) => { return k.selected })
               if(tempqq) {
                   tempKindActiveLists.push(tempqq)
               }else {
                   tempKindActiveLists.push(value)
               }
            })
            this.kindActiveLists = tempKindActiveLists
            this.brandData = res
        } catch (error) {
            console.error(error)
        }
    },
    // 获取图片链接
    getImgUrl(item) {
        return item.touPic || item.baiPic || item.photo || 'https://www1.pcauto.com.cn/2022/kuaisou/images/car-img-default_200x150.png'
    }
  },
  watch: {
      price() {
           this.reqBrand()
      },
      kid() {
          this.reqBrand()
      }
  },
};
</script>

<style lang="scss" scoped>
.selectTable {
    border: 1px solid #d7d7d7;
    background: #fcfcfc;
    color: #333333;
    padding-bottom: 1px;    
    margin-bottom: 25px;
    .border {
        border-bottom: #eeeeee 1px solid;
    }  
    .brand {
        height: 94px;
        position: relative;
        img {
            position: relative;
            top: 15px;
            left: 15px;
            height: 64px;
            width: 64px;    
            border: 0;
            vertical-align: middle;        
        }
        .info {
            width: 510px;
            position: absolute;
            top: 10px;
            left: 100px;
            strong {
                font-size: 16px;
                line-height: 28px;   
                a {
                    color: #225599;                    
                }             
            }   
            .doc {
                line-height: 20px;
                height: 40px;
                overflow: hidden;
                a {
                    color: #225599;                    
                }
            }        
        }
    }    
    a {
        color: #000;
        text-decoration: none;
        outline: none;        
    }
    .border {
        border-bottom: #eeeeee 1px solid;        
    }  
    .price {
        display: flex;
        span {
            display: block;
            padding: 15px 0 10px 0;   
            .normal {
                line-height: 20px;
                color: #225599;
                display: inline-block;
                margin-left: 8px;
                padding: 0 4px;                
            }   
            .select {
                background: #225599!important;
                color: #fff!important;                
            }      
        }
    }
    .w70 {
        width: 70px;
        text-align: right;
        overflow: hidden;        
    }
    .ks_price {
        .w500 {
            display: flex;
            flex-wrap: wrap;
        }
    }
    .w500 {
        width: 500px;
        position: relative;
        .null {
            line-height: 20px;
            background: none;
            cursor: default;
            color: #777;
            text-decoration: none;
            margin-left: 8px;
            padding: 0 4px;
            pointer-events: none;            
        }        
    }
    .ul-wrap {
        display: flex;
        margin-top: -40px;
        margin-left: -10px;
    }
    .selectUl {
        min-width: 100px;
        position: relative;
        // left: 3px;
        top: 55px;
        background: #fcfcfc;
        height: 28px;
        overflow: hidden;
        z-index: 3;
        height: 28px;
        border: solid 2px transparent;
        box-sizing: border-box;
        li {
            line-height: 28px;
            height: 28px;
            overflow: hidden;
            vertical-align: bottom; 
            box-sizing: border-box;
            a {
                display: block;
                color: #225599;
                background: #fcfcfc; 
                text-align: center;
                // padding: 0 20px;
                 &:hover {
                    background-color: #ffeabd;
                }  
            }
            .on {
                position: absolute;
                min-width: 70px;
                // top: 3px;
                left: 8px;
                line-height: 25px;
                color: #fff;
                // background: #225599
                background-color: #fff;;
                color: #225599;
                padding: 0 5px;
                z-index: 99;
                &.active {
                    background-color: #225599;
                    color: #fcfcfc;
                }
            }
        }
         &:hover {
            height: auto;
            border: #225599 2px solid;
            .iDown {
                background-position: 0 -33px;
            }
             li {
                 .on {
                     display: none !important;
                 } 
             }
        } 
        .noAc {
            color: #777;
            pointer-events:none;           
        }
        .iDown {
            display: block;
            width: 7px;
            height: 4px;
            position: absolute;
            right: 2px;
            top: 11px;
            background: url($imageURL) no-repeat;
            overflow: hidden;
            background-position: 0 -29px;
        }
    }  
    .ks_car {
        display: flex;
        align-items: center;
    }
    .w540 {
        width: 540px;
        padding-top: 12px!important;
        padding-bottom: 5px!important;
    }   
    .border3 {
        border-bottom: 1px dashed #e3e3e3;
    }
    .rmcx {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: flex-start;
        padding-bottom: 10px;
        width: 540px;
        li {
            margin-left: 43px;
            width: 120px;
            display: inline-flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        p {
            line-height: 17px;
            word-break: break-all;
            word-wrap: break-word;
            text-align: center;    
        }
        .p1 {
            a {
                color: #225599;
            }
        }
        .p2 {
            a {
                color: #cc0000;
                font-weight: 500;
            }
        }
        .car-img-link{
            display: block;
        }
        .car-img{
            width: 100px;
            height: 75px;
            object-fit: contain;
        }
    }
    .ml20 {
        margin-left: 6px!important;
    }
    .more {
        display: flex;
        justify-content: center;
        background: #f4f4f4;
        width: 616px;
        height: 26px;
        line-height: 26px;
        margin: 0 auto;
        color: #333333;
    }
    .ks_level {
        height: 91px;
    }
    .display-none {
        display: none !important;
    }
    .lab-color {
        &:hover {
            background-color: #ffeabd;
        }
    }
}
</style>
